import { useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./testGenAI.css";
import axios from "axios";

import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import captions from "../../../config/captions.json";

import AIChatHomePage from "./AIChatHomePage";
import ChatMessagesPage from "./ChatMessages";
import ChatHistoryPage from "./ChatHistoryPage";

const CHCodeGenAI = (props) => {
  const chatWrapperRef = useRef();
  const [view, setView] = useState("home"); // 'home' | 'chat' | 'history'
  const [question, setQuestion] = useState("");
  const [onRequest, setOnRequest] = useState(false);
  const [messages, setMessages] = useState([]);
  const [displayName, setDisplayName] = useState("");
  const [menuCode] = useState(
    props.location.pathname.split("/")[2].split("+")[2]
  );
  const [appCode] = useState(props.location.pathname.split("/")[1]);
  const [submenuCode, setSubmenuCode] = useState("");
  const [projectId, setProjectId] = useState("");
  const [siteId, setSiteId] = useState("");
  const [, setParentNodeId] = useState("");
  const [conversationId, setConversationId] = useState(uuidv4());
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const messageType = {
    answer: "assistant",
    question: "user",
  };
  useEffect(() => {
    setUserName(
      sessionStorage.getItem("givenName") === null ||
        sessionStorage.getItem("givenName") === "undefined"
        ? ""
        : sessionStorage.getItem("givenName")
    );
    setUserEmail(
      sessionStorage.getItem("email") === null ||
        sessionStorage.getItem("email") === "undefined"
        ? ""
        : sessionStorage.getItem("email")
    );
    var project = sessionStorage.getItem("selectedProjectIndex");
    var site = sessionStorage.getItem("selectedSiteIndex");
    var projectDetails =
      JSON.parse(sessionStorage.getItem("UserDetails")) != null
        ? JSON.parse(sessionStorage.getItem("UserDetails")).data.User.rights
            .Projects
        : {};

    var menus = projectDetails[project].sites[site].menus;
    if (projectDetails.length > 0 && menus !== undefined) {
      setProjectId(projectDetails[project].projectId);
      setSiteId(projectDetails[project].sites[site].siteid);
      menus.forEach((item) => {
        if (item.code === menuCode) {
          let submenuList = item.submenus;
          submenuList.forEach((element) => {
            if (element.submenuCode === appCode) {
              setDisplayName(element.displayName);
              setSubmenuCode(element.submenuCode);
            }
          });
        }
      });
    }
    sessionStorage.setItem(
      "pageDisplayName" +
        sessionStorage.selectedProjectIndex +
        sessionStorage.selectedSiteIndex,
      displayName
    );
    sessionStorage.setItem(
      "pagePath" +
        sessionStorage.selectedProjectIndex +
        sessionStorage.selectedSiteIndex,
      "/" + submenuCode
    );
  }, [props, userName, messages, onRequest]);

  const onSelectConversation = async (conversationId) => {
    setMessages([]);
    const api_url =
      window.configs.BASE_API_URL + window.configs.CONVERSATION_URL;
    const queryParams = {
      conversation_id: conversationId,
    };
    const apiUrlWithParams = `${
      api_url + "/" + userEmail
    }?${new URLSearchParams(queryParams).toString()}`;

    axios
      .get(apiUrlWithParams)
      .then((response) => {
        if (response.status === 200) {
          var response_all_Conversations = response.data;
          setMessages(response_all_Conversations.chat_messages);
          setConversationId(response_all_Conversations.conversation_id);
          setView("chat");
        }
      })
      .catch((error) => {
        toast.info("Something went wrong", {
          duration: 1000,
          position: "bottom-right",
          theme: "colored",
        });
      });
  };

  const getCaptionsAnswer = async (qData, firstRequest) => {
    if (onRequest) return;

    const newMsgs = [
      ...messages,
      {
        role: messageType.question,
        content: qData,
      },
    ];
    setMessages(newMsgs);
    setQuestion("");
    setOnRequest(true);
    setView("chat");

    const api_url =
      window.configs.BASE_API_URL +
      window.configs.CH_CODE_GEN_URL +
      "/completion/" +
      userEmail;
    const payload = {
      project_id: projectId,
      site_id: siteId,
      prompt: qData,
      app_name: submenuCode,
      parent_node: firstRequest ? "newchat" : uuidv4(),
      conversation_id: conversationId,
    };

    try {
      const response = await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      /*  {"prompt" : "xyz" , "index" : "gen-index", messages: []}*/
      if (response.status === 200) {
        setView("chat");
        const decoder = new TextDecoder();
        const reader = response.body.getReader();
        var chunks = "";
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            setOnRequest(false);
            break;
          }

          chunks += decoder.decode(value);
          setMessages([
            ...newMsgs,
            {
              role: messageType.answer,
              content: chunks.replace(/^None/, "").trim(),
            },
          ]);
        }

        if (firstRequest) {
          getConversationTitle(conversationId, [
            {
              role: messageType.question,
              content: qData,
            },
          ]);
        }
      } else {
        toast.info("Something went wrong", {
          duration: 1000,
          position: "bottom-right",
          theme: "colored",
        });
        setOnRequest(false);
      }
    } catch (err) {
      toast.info("Something went wrong", {
        duration: 1000,
        position: "bottom-right",
        theme: "colored",
      });

      setOnRequest(false);
      //setNewChat(true);
      //setGoToChatHistory(false);
      //return { err };
    }
  };

  const getConversationTitle = async (conversationId, firstMessages) => {
    const api_url =
      window.configs.BASE_API_URL +
      window.configs.CH_GEN_TITLE_URL +
      "/" +
      userEmail;
    const payload = {
      messages: firstMessages,
      conversation_id: conversationId,
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      /*  {"prompt" : "xyz" , "index" : "gen-index", messages: []}*/
      if (response.status === 200) {
      } else {
        toast.info("Something went wrong", {
          duration: 1000,
          position: "bottom-right",
          theme: "colored",
        });
      }
    } catch (err) {
      toast.info("Something went wrong", {
        duration: 1000,
        position: "bottom-right",
        theme: "colored",
      });

      //setNewChat(true);
      //setGoToChatHistory(false);
      return { err };
    }
  };

  const onEnterPress = (e, firstRequest) => {
    if (e.keyCode === 13 && question !== "")
      getCaptionsAnswer(question, firstRequest);
  };

  return (
    <>
      {view === "home" && (
        <AIChatHomePage
          displayName={displayName}
          question={question}
          setQuestion={setQuestion}
          onRequest={onRequest}
          getCaptionsAnswer={() => getCaptionsAnswer(question, true)}
          onEnterPress={(e) => onEnterPress(e, true)}
          onViewHistory={() => setView("history")}
          chatWrapperRef={chatWrapperRef}
          mainPageCaptions={captions.labels.CH_CODE_GEN.genericText}
          botIconImg={"ch-code-ai.jpeg"}
        />
      )}

      {view === "chat" && (
        <ChatMessagesPage
          displayName={displayName}
          messages={messages}
          messageType={messageType}
          userName={userName}
          botName={captions.labels.CH_CODE_GEN.botName}
          botIconImg={"ch-code-ai.jpeg"}
          onNewChat={() => {
            setMessages([]);
            setParentNodeId("newchat");
            setConversationId(uuidv4());
            setView("home");
          }}
          onViewHistory={() => setView("history")}
          question={question}
          setQuestion={setQuestion}
          onRequest={onRequest}
          getCaptionsAnswer={() => getCaptionsAnswer(question, false)}
          onEnterPress={(e) => onEnterPress(e, false)}
          chatWrapperRef={chatWrapperRef}
        />
      )}
      {view === "history" && (
        <ChatHistoryPage
          displayName={displayName}
          messages={messages}
          userName={userName}
          userEmail={userEmail}
          projectId={projectId}
          siteId={siteId}
          submenuCode={submenuCode}
          onNewChat={() => {
            setMessages([]);
            setParentNodeId("newchat");
            setConversationId(uuidv4());
            setView("home");
          }}
          onSelectConversation={onSelectConversation}
          chatWrapperRef={chatWrapperRef}
        />
      )}
    </>
  );
};

export default CHCodeGenAI;
